import React from "react";
import { FiMail } from "react-icons/fi";
import { AiOutlineGithub, AiFillLinkedin } from "react-icons/ai";
import { FaRegFilePdf } from "react-icons/fa";
import profilePic from "../../img/CarlosQProFP.jpg";
import Title from "./Title";

const Profile = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-lg-4 col-md-12 col-sm-12">
          <div id="Profile">
            <img id="profileP" src={profilePic} alt="Profile Pic" />
            <div className="ProfileTit">
              <h2>Carlos Quintero Moreno</h2>
              <h4>Full Stack Web Developer</h4>
            </div>
            <ul className="NetworkIcon">
              <a
                href="mailto:carlosquintero92.cq@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <i>
                  <FiMail id="Icon" />
                </i>
              </a>
              <a
                href="https://github.com/CarlosRQuinteroM"
                target="_blank"
                rel="noreferrer"
              >
                <i>
                  <AiOutlineGithub id="Icon" />
                </i>
              </a>
              <a
                href="https://www.linkedin.com/in/carlos-quintero-moreno/"
                rel="noreferrer"
                target="_blank"
              >
                <i>
                  <AiFillLinkedin id="Icon" />
                </i>
              </a>
              <a
                href="https://docs.google.com/document/d/1XKpEJI99qi9QaIC5ter3kTOb0vEMOrSNgTQWgTUKzoY/edit?usp=sharing"
                rel="noreferrer"
                target="_blank"
              >
                <i>
                  <FaRegFilePdf id="Icon" />
                </i>
              </a>
            </ul>
          </div>
        </div>
        <div className="col-12 col-lg-8 col-md-12 col-sm-12 ">
          <div>
            <Title />
            <br></br>
            <p>
              I'm an ambitious Full Stack Developer with a lot of curiosity and
              desire to always be learning and discovering new things. I am a
              highly organized, reliable and creative person who thrives when
              working in a team within a fast-paced environment.
            </p>

            <p>
              My background in Sales provided me with invaluable skills such as
              strong time management and organization, the ability to work with
              multiple stakeholders, as well as teamwork and flexibility.
            </p>

            <p>
              Eventually I discovered the web development field and from there
              my continued interest led me to study at GeeksHubs Academy and
              realize my dream to become a developer.
            </p>
            <p>
              Current Stack: React.js, Redux, JavaScript/TypeScript, NestJs,
              NextJs.PostgreSQL, Node.js, MongoDB (MERN), React Native MySQL,
              Workbench, Heroku, Bootstrap, Material-ui , AWS.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
